module.exports = __webpack_public_path__ + "media/images/lb/278-a06658a22626b28481e4232fc202cb02.svg";